import React, { useState, useEffect } from 'react';
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { SentenceQATable } from "../components/sentences_questions_answers/SentenceQATable";

import { SentenceAnswerDialog } from "../components/sentences_questions_answers/SentenceAnswerDialog";
import { SentenceQuestionDialog } from "../components/sentences_questions_answers/SentenceQuestionDialog";

// import data_response from "../assets/json/data_response.json"
// import data_question from "../assets/json/data_question.json"
import { useDataProvider } from "../api/DataProvider";


export function SentencesDB() {
    const { json_data_answer, json_data_question } = useDataProvider();
    const [ openSentenceQuestionElementSelected, setOpenSentenceQuestionElementSelected ] = useState(null)
    const [ openSentenceAnswerElementSelected, setOpenSentenceAnswerElementSelected ] = useState(null)
    const [ arr_question_data, setArr_question_data ] = useState([])
    const [ arr_awnswer_data, setArr_answer_data ] = useState([])

    useEffect(() => {
        
        if (json_data_answer !== null && json_data_question !== null){
            console.log("🚀 ~ useEffect ~ json_data_question:", json_data_question)
            console.log("🚀 ~ useEffect ~ json_data_answer:", json_data_answer)
            setArr_answer_data(json_data_answer)
            setArr_question_data(json_data_question)
        }else{
            setArr_answer_data([])
            setArr_question_data([])
        }

    },[json_data_question, json_data_answer]);

    useEffect(() => {
        console.log("🚀 ~ file: SentencesDB.js:38 ~ SentencesDB ~ openSentenceQuestionElementSelected:", openSentenceQuestionElementSelected)
    },[openSentenceQuestionElementSelected]);

    useEffect(() => {
        console.log("🚀 ~ file: SentencesDB.js:38 ~ SentencesDB ~ openSentenceAnswerElementSelected:", openSentenceAnswerElementSelected)
    },[openSentenceAnswerElementSelected]);
    


    return (
        <HomeWrapper>
            <SentenceQATable arr_question_data={arr_question_data} arr_awnswer_data={arr_awnswer_data} setOpenSentenceQuestionElementSelected={setOpenSentenceQuestionElementSelected} setOpenSentenceAnswerElementSelected={setOpenSentenceAnswerElementSelected}/>
            <SentenceQuestionDialog 
                arr_question_data={arr_question_data} 
                arr_awnswer_data={arr_awnswer_data} 
                setOpenSentenceQuestionElementSelected={setOpenSentenceQuestionElementSelected} 
                setOpenSentenceAnswerElementSelected={setOpenSentenceAnswerElementSelected} 
                openSentenceQuestionElementSelected={openSentenceQuestionElementSelected}
                />
            
            <SentenceAnswerDialog 
                arr_question_data={arr_question_data} 
                arr_awnswer_data={arr_awnswer_data} 
                setOpenSentenceQuestionElementSelected={setOpenSentenceQuestionElementSelected} 
                setOpenSentenceAnswerElementSelected={setOpenSentenceAnswerElementSelected} 
                openSentenceAnswerElementSelected={openSentenceAnswerElementSelected}
                />
        </HomeWrapper>
    );
}